import React, { Component, PropTypes } from 'react';
import { RaisedButton, TextField } from 'material-ui';
import * as Icons from 'components/Material/SvgIcons';
import PageModule from 'components/PageModule';
// import PUBNUB from 'services/Pubnub';
import Loader from 'components/Material/Loader';

// https://webrtcexperiment-webrtc.netdna-ssl.com/websocket/PeerConnection.js
!(function() {
  function e(e, n) {
    function t() {
      (o.stopBroadcasting = !0), e.MediaStream && e.MediaStream.stop();
      for (var n in e.peers) e.peers[n].peer.close();
      e.peers = {};
    }
    function a(n) {
      var i = JSON.parse(n.data);
      i.userid != e.userid &&
        ((e.participant = i.userid),
        console.debug(
          JSON.stringify(
            i,
            function(e, n) {
              return n && n.sdp
                ? (console.log(n.sdp.type, '---', n.sdp.sdp), '')
                : n;
            },
            '---'
          )
        ),
        i.sdp && i.to == e.userid && o.onsdp(i),
        i.candidate && i.to == e.userid && o.onice(i),
        i.participationRequest &&
          i.to == e.userid &&
          ((o.participantFound = !0),
          e.onParticipationRequest
            ? e.onParticipationRequest(i.userid)
            : e.acceptRequest(i.userid)),
        i.broadcasting && e.onUserFound && e.onUserFound(i.userid),
        i.userLeft && i.to == e.userid && t());
    }
    var o = this;
    (e.startBroadcasting = function() {
      if (!e.MediaStream) throw 'Offerer must have media stream.';
      !(function n() {
        c.send({ userid: e.userid, broadcasting: !0 }),
          !o.participantFound && !o.stopBroadcasting && setTimeout(n, 3e3);
      })();
    }),
      (e.sendParticipationRequest = function(n) {
        c.send({ participationRequest: !0, userid: e.userid, to: n });
      }),
      (this.onsdp = function(n) {
        var t = n.sdp;
        'offer' == t.type &&
          (e.peers[n.userid] = g.createAnswer(
            i(s, { MediaStream: e.MediaStream, sdp: t })
          )),
          'answer' == t.type && e.peers[n.userid].setRemoteDescription(t);
      }),
      (e.acceptRequest = function(n) {
        e.peers[n] = w.createOffer(i(s, { MediaStream: e.MediaStream }));
      });
    var d = [];
    this.onice = function(n) {
      var t = e.peers[n.userid];
      if (t) {
        t.addIceCandidate(n.candidate);
        for (var i = 0; i < d.length; i++) t.addIceCandidate(d[i]);
        d = [];
      } else d.push(d);
    };
    var s = {
      onsdp: function(n) {
        c.send({ userid: e.userid, sdp: n, to: e.participant });
      },
      onicecandidate: function(n) {
        c.send({ userid: e.userid, candidate: n, to: e.participant });
      },
      onStreamAdded: function(n) {
        function t() {
          e.onStreamAdded && e.onStreamAdded(a);
        }
        console.debug('onStreamAdded', '>>>>>>', n),
          (n.onended = function() {
            e.onStreamEnded && e.onStreamEnded(a);
          });
        var i = document.createElement('video');
        (i.id = e.participant),
          (i[r ? 'mozSrcObject' : 'src'] = r
            ? n
            : window.webkitURL.createObjectURL(n)),
          (i.autoplay = !0),
          (i.controls = !0),
          i.play();
        var a = {
          mediaElement: i,
          stream: n,
          userid: e.participant,
          type: 'remote'
        };
        t();
      }
    };
    (e.close = function() {
      c.send({ userLeft: !0, userid: e.userid, to: e.participant }), t();
    }),
      (window.onbeforeunload = function() {
        e.close();
      }),
      (window.onkeyup = function(n) {
        116 == n.keyCode && e.close();
      });
    var c = n;
    'string' == typeof n &&
      ((c = new WebSocket(n)),
      (c.push = c.send),
      (c.send = function(e) {
        c.push(JSON.stringify(e));
      }),
      (c.onopen = function() {
        console.log('websocket connection opened.');
      })),
      (c.onmessage = a);
  }
  function n() {
    return Math.round(9999999999 * Math.random()) + 9999999999;
  }
  function t() {}
  function i(e, n) {
    for (var t in n) e[t] = n[t];
    return e;
  }
  window.PeerConnection = function(t, i) {
    if (((this.userid = i || n()), (this.peers = {}), !t))
      throw 'Socket-URL is mandatory.';
    new e(this, t),
      (this.addStream = function(e) {
        this.MediaStream = e;
      });
  };
  var a = window.mozRTCPeerConnection || window.webkitRTCPeerConnection,
    o = window.mozRTCSessionDescription || window.RTCSessionDescription,
    d = window.mozRTCIceCandidate || window.RTCIceCandidate;
  (navigator.getUserMedia =
    navigator.mozGetUserMedia || navigator.webkitGetUserMedia),
    (window.URL = window.webkitURL || window.URL);
  var r = !!navigator.mozGetUserMedia,
    s = !!navigator.webkitGetUserMedia,
    c = { url: s ? 'stun:stun.l.google.com:19302' : 'stun:23.21.150.121' },
    u = { url: 'turn:homeo@turn.bistri.com:80', credential: 'homeo' },
    p = { iceServers: [c] };
  s &&
    (parseInt(navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)[2]) >= 28 &&
      (u = {
        url: 'turn:turn.bistri.com:80',
        credential: 'homeo',
        username: 'homeo'
      }),
    (p.iceServers = [c, u]));
  var f = { optional: [{ DtlsSrtpKeyAgreement: !0 }] },
    m = {
      optional: [],
      mandatory: { OfferToReceiveAudio: !0, OfferToReceiveVideo: !0 }
    },
    w = {
      createOffer: function(e) {
        var n = new a(p, f);
        return (
          e.MediaStream && n.addStream(e.MediaStream),
          (n.onaddstream = function(n) {
            e.onStreamAdded(n.stream);
          }),
          (n.onicecandidate = function(n) {
            n.candidate && e.onicecandidate(n.candidate);
          }),
          n.createOffer(
            function(t) {
              n.setLocalDescription(t), e.onsdp(t);
            },
            t,
            m
          ),
          (this.peer = n),
          this
        );
      },
      setRemoteDescription: function(e) {
        this.peer.setRemoteDescription(new o(e));
      },
      addIceCandidate: function(e) {
        this.peer.addIceCandidate(
          new d({ sdpMLineIndex: e.sdpMLineIndex, candidate: e.candidate })
        );
      }
    },
    g = {
      createAnswer: function(e) {
        var n = new a(p, f);
        return (
          e.MediaStream && n.addStream(e.MediaStream),
          (n.onaddstream = function(n) {
            e.onStreamAdded(n.stream);
          }),
          (n.onicecandidate = function(n) {
            n.candidate && e.onicecandidate(n.candidate);
          }),
          n.setRemoteDescription(new o(e.sdp)),
          n.createAnswer(
            function(t) {
              n.setLocalDescription(t), e.onsdp(t);
            },
            t,
            m
          ),
          (this.peer = n),
          this
        );
      },
      addIceCandidate: function(e) {
        this.peer.addIceCandidate(
          new d({ sdpMLineIndex: e.sdpMLineIndex, candidate: e.candidate })
        );
      }
    };
  (window.URL = window.webkitURL || window.URL),
    (navigator.getMedia =
      navigator.webkitGetUserMedia || navigator.mozGetUserMedia),
    (navigator.getUserMedia = function(e, n, t) {
      function i(e) {
        n(e);
      }
      function a(e) {
        if (!t)
          throw Error('getUserMedia failed: ' + JSON.stringify(e, null, '   '));
        t(e);
      }
      if ((e || (e = { audio: !0, video: !0 }), !n))
        throw 'Second argument is mandatory. navigator.getUserMedia(hints,onsuccess,onfailure)';
      navigator.getMedia(e, i, a);
    });
})();

const channel = 'coursio';
const pub = 'pub-c-24e38eb9-8fa9-420e-85c9-9046088fe686';
const sub = 'sub-c-ecad80ec-9b3e-11e5-bcd8-0619f8945a4f';

const styles = {
  video: {
    width: '100%'
  },
  box: {
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    display: 'inline-block',
    width: '50%'
  }
};

export default class Webinar extends PageModule {
  static readable = 'Webinar';
  static icon = 'NotificationLiveTv';
  static type = 1001;
  static public = false;
  static active = true;

  peer = null;
  broadcasterId = null;
  state = {
    ownVideoStream: null,
    videos: []
  };

  onInit() {
    const WebSocket = PUBNUB.ws;
    const websocket = new WebSocket(
      'wss://pubsub.pubnub.com/' + pub + '/' + sub + '/' + channel
    );

    websocket.onerror = function() {};
    websocket.onclose = function() {};
    websocket.push = websocket.send;
    websocket.send = function(data) {
      websocket.push(JSON.stringify(data));
    };

    this.peer = new PeerConnection(websocket);

    this.peer.onUserFound = userid => {
      this.broadcasterId = userid;
      document.getElementById('broadcaster-info').innerHTML =
        'User ' + userid + ' started a webinar.';
    };

    this.peer.onStreamAdded = e => {
      const { videos } = this.state;

      videos.push({
        userid: e.userid,
        stream: e.stream
      });
      this.setState({ videos });
    };

    this.peer.onStreamEnded = function(e) {};
  }

  createVideoBox() {}

  getUserMedia(callback) {
    const hints = {
      audio: true,
      video: {
        optional: [],
        mandatory: {}
      }
    };
    navigator.getUserMedia(hints, stream => {
      this.setState({
        ownVideoStream: {
          userid: 'self',
          stream,
          callback
        }
      });
    });
  }

  startBroadcast() {
    this.peer.userid = this.props.user.displayName;
    this.getUserMedia(stream => {
      this.peer.addStream(stream);
      this.peer.startBroadcasting();
    });
  }

  connectToBroadcast() {
    this.getUserMedia(stream => {
      this.peer.addStream(stream);
      this.peer.sendParticipationRequest(this.broadcasterId);
    });
  }

  zoomVideo(index) {
    const videos = this.state.videos.slice();
    videos[index].zoom = !vides[index].zoom;
    this.setState({ videos });
  }

  zoomOwnVideo(index) {
    const ownVideoStream = this.state.ownVideoStream;
    ownVideoStream.zoom = !ownVideoStream.zoom;
    this.setState({ ownVideoStream });
  }

  renderVideos() {
    return this.state.videos.map((video, index) => {
      return (
        <VideoContainer
          zoom={video.zoom}
          onTouchTap={this.zoomVideo.bind(this, index)}
          key={index}
          peer={this.peer}
          userid={video.userid}
          stream={video.stream}
          callback={video.callback}
        />
      );
    });
  }

  renderEditMode(data) {
    const ownVideo = this.renderOwnVideo();
    return (
      <div>
        <RaisedButton
          label="Start broadcasting"
          onTouchTap={::this.startBroadcast}
        />
        <div id="broadcaster-info" />
        <div>{ownVideo}</div>
        <div>{this.renderVideos()}</div>
      </div>
    );
  }

  renderOwnVideo() {
    if (this.state.ownVideoStream) {
      console.log(this.state.ownVideoStream);
      const { callback, zoom, stream } = this.state.ownVideoStream;
      return (
        <VideoContainer
          onTouchTap={::this.zoomOwnVideo}
          zoom={zoom}
          userid="self"
          callback={callback}
          stream={stream}
        />
      );
    }
    return <Loader />;
  }

  renderDetailMode(data) {
    const ownVideo = this.renderOwnVideo();
    return (
      <div>
        <RaisedButton label="Connect" onTouchTap={::this.connectToBroadcast} />
        <div id="broadcaster-info" />
        <div>{ownVideo}</div>
        <div>{this.renderVideos()}</div>
      </div>
    );
  }
}

class VideoContainer extends Component {
  static displayName = 'VideoContainer';

  static propTypes = {
    peer: PropTypes.object,
    userid: PropTypes.string,
    stream: PropTypes.object,
    callback: PropTypes.func,
    zoom: PropTypes.bool
  };

  componentDidMount() {
    const { callback, stream } = this.props;
    const mediaElement = this.refs.video;
    // this.props.peer.onStreamAdded({
    //   mediaElement,
    //   userid,
    //   stream
    // });
    mediaElement.play();
    if (callback) {
      callback(stream);
    }
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.stream !== this.props.stream;
  }

  getStyle() {
    const { zoom } = this.props;
    return Object.assign({}, styles.box, {
      width: zoom ? '100%' : '50%'
    });
  }

  render() {
    const { userid, stream, ...other } = this.props;
    const title = userid === 'self' ? 'Ground Control' : 'Major Tom';
    return (
      <div style={::this.getStyle()} {...other}>
        <video
          ref="video"
          controls
          src={URL.createObjectURL(stream)}
          style={styles.video}
        />
        <div>{title}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/plugins/PageModules/Webinar.js